import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminProtected = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const isLoggedIn = useSelector((state) => state.signin_reducer.isLoggedIn);
// navigate to landing page if user not logged in or not admin
    if ((!isLoggedIn && !user) || (user && user.user.role !== 3)) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
};

export default AdminProtected;